import React,{useState,useEffect} from "react";
import './classes/ReferralWalletReport.css';
import { configData } from "../config";
import Loading from './Loading';
import Select from 'react-dropdown-select';
import { Helmet } from 'react-helmet';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DataGrid } from '@mui/x-data-grid';
 import { Link } from '@mui/material';
 import { format } from "date-fns";

const ReferralWalletReport = ()=>{
      const initialForm = () => {
        const params = new URLSearchParams(window.location.search);
      const defaultForm = {    
        start_date: '',
        end_date: '',
        pay_start_date: '',
        pay_end_date: '',
        start_date_obj: null,
        end_date_obj: null,
        pay_start_date_obj: null,
        pay_end_date_obj: null,
        salesperson: 'ALL',
        view: '',
        action:''
      };    
       //  normal dates
        const queryStart = params.get("start_date");
        const queryEnd = params.get("end_date");

        const startObj =
            queryStart
            ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
            : null;

        const endObj =
            queryEnd
            ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
            : null;

        //  payment dates
        const queryPaydayStart = params.get("pay_start_date");
        const queryPaydayEnd = params.get("pay_end_date");

        const paydayStartObj =
            queryPaydayStart
            ? new Date(queryPaydayStart.replace(/-/g, "/") + " 00:00:00")
            : null;

        const paydayEndObj =
            queryPaydayEnd
            ? new Date(queryPaydayEnd.replace(/-/g, "/") + " 00:00:00")
            : null;

        const queryView = params.get("view") || ''; 

        return {
            ...defaultForm,
            salesperson: params.get("salesperson") || defaultForm.salesperson,
            roles: params.get("roles") || defaultForm.roles,

            //  normal dates
            start_date: startObj ? queryStart : '',
            start_date_obj: startObj,

            end_date: endObj ? queryEnd : '',
            end_date_obj: endObj,

            //  payment dates
            pay_start_date: paydayStartObj ? queryPaydayStart : '',
            pay_start_date_obj: paydayStartObj,

            pay_end_date: paydayEndObj ? queryPaydayEnd : '',
            pay_end_date_obj: paydayEndObj,

            view: queryView,
            action:''
        };
        };       
      const [formData, setFormData] = useState(initialForm);
      const [formErrors, setFormErrors] =useState({});
      const [submittedData, setSubmittedData] = useState(null);   
      const [isLoading, setIsLoading] = useState(true);
      const [paidreferee, setPaidReferee] = useState({});
      const [unpaidreferee, setUnPaidReferee] = useState({});
      const [totalreferee, setTotalReferee] = useState({});
       const [paidreferee1, setPaidReferee1] = useState({});
      const [unpaidreferee1, setUnPaidReferee1] = useState({});
      const [totalreferee1, setTotalReferee1] = useState({});
      const [openTotalTable, setOpenTotalTable] = useState({});
       const [openPaidTable, setOpenPaidTable] = useState({});
        const [openUnPaidTable, setOpenUnPaidTable] = useState({});
      const [totaltableContent, setTotalTableContent] = useState({});
      const [paidtableContent, setPaidTableContent] = useState({});
      const [unpaidtableContent, setUnPaidTableContent] = useState({});
        const [isSubmitted, setIsSubmitted] = useState(false);  
       
   
         const[salespersonList, setSalespersonList] = useState({});
           const[submittedsalespersonList, setSubmittedSalespersonList] = useState({});
         const app_url = configData.APP_URL;
        useEffect(() => {
           Promise.all([
          
          getsalespersonlist(),
          
          ]).then(() => {
     
            setIsLoading(false);
          })
        }, []);

   
  async function getsalespersonlist() {
    
         try {
            const response = await fetch(
                app_url+'user/getsalespersonlistwithunassigned',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
                
              
            } 
        } catch (err) {
            
         }
        
  }
const handleClick = (content,salespersonid) => {
  
 if (content == "total_length") {
   setOpenTotalTable(prev => ({
        ...prev,
        [salespersonid]: !prev[salespersonid]
    }));
     setTotalTableContent({content:content,
    id:salespersonid
  });
  
}


  if(content == "paid_referee_length") {
    
     setOpenPaidTable(prev => ({
        ...prev,
        [salespersonid]: !prev[salespersonid]
    }));
     setPaidTableContent({content:content,
    id:salespersonid
  });
  }
    if(content == "unpaid_referee_length") {
  
   setOpenUnPaidTable(prev => ({
        ...prev,
        [salespersonid]: !prev[salespersonid]
    }));
   setUnPaidTableContent({content:content,
    id:salespersonid
  });
    }
};
    
 
    const columnsmain = [
    {
    field: 'referee_doa',
    headerName: 'Date of App (of the Referee)',   
    flex:1,  
    sortable: false,
    // minWidth:82,
    cellClassName:'date_of_app_column',headerClassName:'date_of_app_header',
  },
  {
    field: 'referer_name',
    headerName: 'Name (of the Referrer)',      
    flex:1,
    sortable: false,
    // minWidth:77,
    cellClassName:'name_column',headerClassName:'name_header',
  },
 
    {
    field: 'referer_mail',
    headerName: 'Email (of the Referrer)',
    flex:1,
    sortable: false,
    // minWidth:247,
    cellClassName:'email_column',headerClassName:'email_header', 
     renderCell: (params) => (
    <Link href={params.row.referer_drupal_uid} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.referer_mail}
      </Link>
  ),
    
  },
  {
    field: 'referer_nil',
    headerName: 'NIL Athlete?', 
    sortable: false,  
    flex:1,
    // minWidth:67,
    cellClassName:'nil_column',headerClassName:'nil_header',
  },
      {
    field: 'referrer_log',
    headerName: 'Referrer Log',
    flex:1,
    sortable: false,
    // minWidth:65,
    cellClassName:'referrer_log_column',headerClassName:'referrer_log_header', 
     renderCell: (params) => (
    <Link href={params.row.log_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
       Referrer Log
      </Link>
  ),
    
  },
  {
    field: 'referee_sales',
    headerName: 'Salesperson (of the Referee)',   
    flex:1,
    sortable: false,
    //  minWidth:94,
    cellClassName:'salesperson_column',headerClassName:'salesperson_header',
  },
  {
    field: 'referee_name',
    headerName: 'Referee (Name)',   
    flex:1,
    sortable: false,
    //  minWidth:109,
    cellClassName:'referee_column',headerClassName:'referee_header',
  },
    {
    field: 'referee_mail',
    headerName: "Referee's Email",
    flex:1,
    sortable: false,
    // minWidth:223,
    cellClassName:'referee_email_column',headerClassName:'referee_email_header', 
     renderCell: (params) => (
    <Link href={params.row.referee_drupal_uid} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.referee_mail}
      </Link>
  ),
    
  },

  {
    field: 'referee_status',
    headerName: 'Referee Status',   
    flex:1,
    sortable: false,
    // minWidth:62,
    cellClassName:'referee_status_column',headerClassName:'referee_status_header',
  },
  {
    field: 'updated_at',
    headerName: 'Payment Date',   
    flex:1,
    sortable: false,
    //  minWidth:82,
    cellClassName:'payment_date_column',headerClassName:'payment_date_header',
  },

];
 const columnsUpdatedDate = [
    {
    field: 'name_of_salesperson',
    headerName: 'Name Of Salesperson',   
    flex:1,  
    sortable: false,
    minWidth:82,
    cellClassName:'name_of_salesperson_column',headerClassName:'name_of_salesperson_header',
  },
     {
    field: 'total_referrals',
    headerName: 'Total Referrals',
    flex:1,
    sortable: false,
    minWidth:247,
    cellClassName:'total_referrals_column',headerClassName:'total_referrals_header', 
     renderCell: (params) => (
    <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.email}
      </Link>
  ),
    
  },
     {
    field: 'paid_referee',
    headerName: 'Paid Referee',
    flex:1,
    sortable: false,
    minWidth:247,
    cellClassName:'paid_referee_column',headerClassName:'paid_referee_header', 
     renderCell: (params) => (
    <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.email}
      </Link>
  ),
    
  },
 
    {
    field: 'unpaid_referee',
    headerName: 'UnPaid Referee',
    flex:1,
    sortable: false,
    minWidth:247,
    cellClassName:'unpaid_referee_column',headerClassName:'unpaid_referee_header', 
     renderCell: (params) => (
    <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.email}
      </Link>
  ),
    
  },
 ];
  const columnsPaymentDate = [
    {
    field: 'name_of_salesperson',
    headerName: 'Name Of Salesperson',   
    flex:1,  
    sortable: false,
    minWidth:247,
    cellClassName:'name_of_salesperson_column',headerClassName:'name_of_salesperson_header',
  },
     {
    field: 'total_referrals',
    headerName: 'Total Referrals',
    flex:1,
    sortable: false,
    minWidth:247,
    cellClassName:'total_referrals_column',headerClassName:'total_referrals_header', 
     renderCell: (params) => (
    <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.email}
      </Link>
  ),
    
  },
     {
    field: 'paid_referee',
    headerName: 'Paid Referee',
    flex:1,
    sortable: false,
    minWidth:247,
    cellClassName:'paid_referee_column',headerClassName:'paid_referee_header', 
     renderCell: (params) => (
    <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.email}
      </Link>
  ),
    
  },
 
    {
    field: 'unpaid_referee',
    headerName: 'UnPaid Referee',
    flex:1,
    sortable: false,
    minWidth:247,
    cellClassName:'unpaid_referee_column',headerClassName:'unpaid_referee_header', 
     renderCell: (params) => (
    <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.email}
      </Link>
  ),
    
  },
 ];
 /*main-table*/
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  

  const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};


// const handleUpdatedDateChange = (date) => {
//   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//   setFormData(prev => ({ ...prev, start_date: formattedDate }));
// };
// const handleUpdatedEndDateChange = (date) => {
//   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//   setFormData(prev => ({ ...prev, end_date: formattedDate }));
// };
// const handlePaymentDateChange = (date, name) => {
//   const formattedDate = date ? format(date, "yyyy-MM-dd") : '';
//   setFormData(prev => ({ ...prev, [name]: formattedDate }));
// };
const handleDateChange = (date, field) => {
  setFormData(prev => ({
    ...prev,
    [`${field}_obj`]: date,                       // for DatePicker
    [field]: date ? format(date, 'yyyy-MM-dd') : '' // for backend
  }));
};

    React.useEffect(() => {
          
             const fetchData = async () => {
             // Simulate API call to your server
             // In a real application, replace this with your actual fetch logic
              try {
               setIsLoading(true);
             const response = await fetch(app_url+'referralreport/getlist', {
               method: 'POST',
               headers: { 'Content-Type': 'application/json' },
               body: JSON.stringify({
                 page: paginationModel.page,
                 pageSize: paginationModel.pageSize,
                 sortModel,
                 filterModel,
               //  formData:formData
                 formData: {
                  ...formData,
                  action: isSubmitted ? 'submit' : ''
              }
               }),
             });
             const data = await response.json();
             console.log(data.data.rows);
                setRows(data.data.rows);
                setRowCount(data.data.totalRowCount); // Server should return totalRowCount
                setSubmittedSalespersonList(data.data.salesperson_result);
                setPaidReferee(data.data.paid_referee);
                setUnPaidReferee(data.data.unpaid_referee);
                setTotalReferee(data.data.total_referee);
                setPaidReferee1(data.data.paid_referee1);
                setUnPaidReferee1(data.data.unpaid_referee1);
                setTotalReferee1(data.data.total_referee1);
                //setOpenTotalTable(false);
                setOpenTotalTable({});
                setOpenPaidTable({});
                setOpenUnPaidTable({});
             }  catch (error) {
                   console.error('Error fetching data:', error);
                 } finally {
                   setIsLoading(false); // Set loading to false after fetch completes (success or error)
                    if (isSubmitted) {
                        setIsSubmitted(false);
                    }
                 }
                 
           };
           
       
           fetchData();
        
      }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change

          const validateDates = (formData) => {
        let errors = {};

        if (!formData.start_date && formData.end_date) {
            errors.start_date = "Start date is required.";
        }

        if (!formData.end_date && formData.start_date) {
            errors.end_date = "End date is required.";
        }

        if (formData.start_date && formData.end_date) {
            const start = new Date(formData.start_date);
            const end = new Date(formData.end_date);
            if (end < start) {
                errors.end_date = "End date cannot be before start date.";
            }
        }

        if (!formData.pay_start_date && formData.pay_end_date) {
            errors.pay_start_date = "Start date is required.";
        }

        if (!formData.pay_end_date && formData.pay_start_date) {
            errors.pay_end_date = "End date is required.";
        }

        if (formData.pay_start_date && formData.pay_end_date) {
            const start = new Date(formData.pay_start_date);
            const end = new Date(formData.pay_end_date);
            if (end < start) {
                errors.pay_end_date = "End date cannot be before start date.";
            }
        }

        return errors;
    };
      const submitFormData = async (data) => {
        setSubmittedData(data);
        setFormData(data);
        setIsSubmitted(false);
    };
   
   // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault(); // stop page reload
    const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
        console.log("Validation errors:", errors);
        setFormErrors(errors); 
        return;
    }
    setFormErrors({});
    setSubmittedData(formData);
     // Reset pagination state
                setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
     setIsSubmitted(true);
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'referralreport/getlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: 0,
          pageSize: 50,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      setPaidReferee(data.data.paid_referee);
      setUnPaidReferee(data.data.unpaid_referee);
      setTotalReferee(data.data.total_referee);
       setPaidReferee1(data.data.paid_referee1);
      setUnPaidReferee1(data.data.unpaid_referee1);
      setTotalReferee1(data.data.total_referee1);
      //setOpenTotalTable(false);
      setOpenTotalTable({});
     setOpenPaidTable({});
    setOpenUnPaidTable({});
     setSubmittedSalespersonList(data.data.salesperson_result);
    

      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    console.log("Form submitted:", formData);


  };
  const handleExport = async (e) => {
    e.preventDefault(); // stop page reload
   
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'referralreport/getexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          formData:formData
        }),
      });
      const data = await response.json();
      const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };
  
      useEffect(() => {
          const params = new URLSearchParams(window.location.search);
  
          if ([...params.keys()].length > 0) {
          const init = initialForm();
  
          setFormData(init);
  
          submitFormData(init);              
          }
      }, []);

    return(
           <>
            {isLoading ? (
              <Loading />
            ) : (
        <div id="main"  className="referral-wallet-report-main">
                <Helmet>
                    <title>
                        Referral Wallet Report
                    </title>
                </Helmet>
            <div className="left"></div>
            <div className="center left-center">
              <h1>Referral Wallet Report</h1>
                <div className="referral-wallet-report-container">
                <div className="messages warning">
                   <strong>This report includes:</strong><br/>
                   	&nbsp;&nbsp;- If you're looking up large amounts of data, please wait for the report to load.<br/>
	                &nbsp;&nbsp;- If your search is not successful (i.e. system crashes), try narrowing the search.<br/>
                </div> 
                <div className="messages_details">

                <ul>
                    <li><strong>Referrer:</strong> someone who sends us new customers and receives credit on the new customer's first purchase.</li>
                    <li><strong>Referee:</strong> a new customer who is referred by a referrer and receives a discount on their first purchase.</li>

                <li>*Please note that if an already existing user applies a referral coupon to their first purchase, they will receive a discount but their referrer will not.</li>

                <li><strong>Referral:</strong> the process of a referrer referring a new customer.</li>
                <li><strong>Updated Start Date:</strong> The date changes were made to the application.<br/>
                (Example: the user submits another form)</li>

                <li><strong>Payment Start Date:</strong> The date the payment was made.</li>

                </ul>                    
                </div> 
                 <form >                 
                        <div className="full_width">
                            <div className="left_column">
                            <label>
                                Updated Start Date:<br />
                                <DatePicker
                                        selected={formData.start_date_obj}
                                        onChange={(date) => handleDateChange(date, 'start_date')}
                                        id="start_date"
                                        name="start_date" 
                                        className=""
                                        required
                                        /> 
                                {formErrors.start_date && (
                                        <div className="error">{formErrors.start_date}</div>
                                 )}
                            </label>
                           
                            <label>
                                Updated End Date:<br />
                            <DatePicker
                                        selected={formData.end_date_obj}
                                        onChange={(date) => handleDateChange(date, 'end_date')}
                                        id="end_date"
                                        name="end_date"
                                        className=""
                                        required
                                        /> 
                              {formErrors.end_date && (
                                    <div className="error">{formErrors.end_date}</div>
                                )}
                            </label>
                            </div>
                                    <div className="right_column">
                            <label>
                                Payment Start Date:<br />
                            <DatePicker
                                        selected={formData.pay_start_date_obj}
                                        onChange={(date) => handleDateChange(date, 'pay_start_date')}
                                        id="pay_start_date"
                                        name="pay_start_date"
                                        className=""
                                        />
                            {formErrors.pay_start_date && (
                                  <div className="error">{formErrors.pay_start_date}</div>
                              )}
                            </label>
                            
                            <label>
                                Payment End Date:<br />
                            <DatePicker
                                       selected={formData.pay_end_date_obj}
                                        onChange={(date) => handleDateChange(date, 'pay_end_date')}
                                        id="pay_end_date"
                                        name="pay_end_date"
                                        className=""
                                        /> 
                             {formErrors.pay_end_date && (
                                  <div className="error">{formErrors.pay_end_date}</div>
                              )}
                            </label>
                            </div>
                            <div className="third_right_column">
                                      <label>Salesperson: </label>
                                            
                                            <select
                                            className='referral-salesperson-select'
                                            name="salesperson"
                                            value={formData.salesperson}
                                            onChange={handleChange}
                                                                            >
                                                <option value="ALL">ALL</option>
                                            {salespersonList.length > 0 && (
                                                <>
                                                {salespersonList.map((mitem, index) => {
                                                    return <>
                                                        {mitem['uid'] != null && (
                                                        <><option value={mitem['uid']}>{mitem['name']}</option></>
                                                        )}
                                                    </>
                                
                                                })}  
                        
                                                </>
                                            )}
                                            
                                            </select>
                            </div>
                            </div>
                        <div className="referral-form-actions">
                          <input type="submit" value="Submit" className="form-submit"  onClick={handleSubmit}/>&nbsp; &nbsp;
                           <input type="button" value="Export" className="form-submit"  onClick={handleExport}/>&nbsp; &nbsp;
                           <a href="/admin/reports/refererrer_bonus"><input type="button" name="" value="Clear" class="form-submit" /></a>
                        </div>
                 </form>
                 
                 
                  {submittedsalespersonList.length > 0  && Object.values(totalreferee).length > 0 && submittedData.start_date && submittedData.end_date && (
                                                <><table className="referral_count_list"><tbody><tr><th>Name Of Salesperson</th><th>Total Referrals</th><th>Paid Referee</th><th>UnPaid Referee</th></tr>
                                                
                                                {submittedsalespersonList.map((item, index) => {
                                                       
                                                        const paid_referee_length = paidreferee[item['uid']]?Object.keys(paidreferee[item['uid']]).length:0;
                                                        const unpaid_referee_length = unpaidreferee[item['uid']]?Object.keys(unpaidreferee[item['uid']]).length:0;
                                                        const total_length = paid_referee_length+unpaid_referee_length;
                                                    return <>
                                                        {item['uid'] != null && (
                                                          
                                                        <><tr><td>{item['name']}</td>
                                                            <td>
                                                              <a href onClick={() => handleClick('total_length',item['uid'])}>{total_length}</a>
                                                            </td>
                                                            <td>
                                                              <a href onClick={() => handleClick('paid_referee_length',item['uid'])}>{paid_referee_length}</a>
                                                            </td>
                                                            <td>
                                                              <a href onClick={() => handleClick('unpaid_referee_length',item['uid'])}>{unpaid_referee_length}</a>
                                                            </td>
                                                          </tr>
                                                          {openTotalTable[item['uid']] === true && (
                                                           
                                                         <>
                                                             
                                                              {(totaltableContent.content === 'total_length' && item['uid']) && (
                                                                 <tr><td colspan="15">
                                                            <table>
                                                                <tr>
                                                                  <td><table class="table table-bordered table-hover" style={{ width: '80%', margin: 'auto' }}>
				                                                              <tbody><tr align="center"><th colspan="4" align="center">Total Referrals</th></tr>
				                                                                      <tr><th>First Name</th><th>Last Name</th><th>Email</th><th>Referer</th></tr>
                                                                              {totalreferee[item['uid']] && Object.keys(totalreferee[item['uid']]).length > 0 ? (
                                                                                Object.keys(totalreferee[item.uid]).map((citem,cvalue) => (
                                                                                  <><tr><td><a href={totalreferee[item['uid']][citem]['referee_link']}>{totalreferee[item['uid']][citem]['first_name']}</a></td><td><a href={totalreferee[item['uid']][citem]['referee_link']}>{totalreferee[item['uid']][citem]['last_name']}</a></td>
                                                                                  <td>{totalreferee[item['uid']][citem]['email']}</td><td><a href={totalreferee[item['uid']][citem]['referer_link']}>{totalreferee[item['uid']][citem]['referer_name']}</a></td></tr></>
                                                                                 ))) : (
                                                                                   <><td colspan="4" align="center">No salespeople found.</td></>
                                                                                )

                                                                                }
                                                                      </tbody>
                                                                      </table></td>
                                                                </tr>
                                                                 </table>
                                                              </td></tr>
                                                              )}
                                                             
                                                            </>
                                                             )}
                                                              {openPaidTable[item['uid']] === true && (
                                                                <>
                                                              {(paidtableContent.content === 'paid_referee_length' && item['uid']) && (
                                                                <tr><td colspan="15">
                                                            <table>
                                                                <tr>
                                                                  <td><table class="table table-bordered table-hover" style={{ width: '80%', margin: 'auto' }}>
				                                                              <tbody><tr align="center"><th colspan="4" align="center">Paid Referee</th></tr>
				                                                                      <tr><th>First Name</th><th>Last Name</th><th>Email</th><th>Referer</th></tr>
                                                                              {paidreferee[item['uid']] && Object.keys(paidreferee[item['uid']]).length > 0 ? (
                                                                                Object.keys(paidreferee[item.uid]).map((citem,cvalue) => (
                                                                                  <><tr><td><a href={paidreferee[item['uid']][citem]['referee_link']}>{paidreferee[item['uid']][citem]['first_name']}</a></td><td><a href={paidreferee[item['uid']][citem]['referee_link']}>{paidreferee[item['uid']][citem]['last_name']}</a></td>
                                                                                  <td>{paidreferee[item['uid']][citem]['email']}</td><td><a href={paidreferee[item['uid']][citem]['referer_link']}>{paidreferee[item['uid']][citem]['referer_name']}</a></td></tr></>
                                                                                 ))) : (
                                                                                   <><td colspan="4" align="center">No Referrals found.</td></>
                                                                                )

                                                                                }
                                                                      </tbody>
                                                                      </table></td>
                                                                </tr>
                                                                 </table>
                                                              </td></tr>
                                                              )}
                                                              </>
                                                            
                                                             )}
                                                             {openUnPaidTable[item['uid']] === true && (
                                                               <>
                                                              {(unpaidtableContent.content === 'unpaid_referee_length' && item['uid']) && (
                                                                
                                                                 <tr><td colspan="15">
                                                            <table>
                                                                <tr>
                                                                  <td><table class="table table-bordered table-hover" style={{ width: '80%', margin: 'auto' }}>
				                                                              <tbody><tr align="center"><th colspan="4" align="center">UnPaid Referee</th></tr>
				                                                                      <tr><th>First Name</th><th>Last Name</th><th>Email</th><th>Referer</th></tr>
                                                                              {unpaidreferee[item['uid']] && Object.keys(unpaidreferee[item['uid']]).length > 0 ? (
                                                                                Object.keys(unpaidreferee[item.uid]).map((citem,cvalue) => (
                                                                                  <><tr><td><a href={unpaidreferee[item['uid']][citem]['referee_link']}>{unpaidreferee[item['uid']][citem]['first_name']}</a></td><td><a href={unpaidreferee[item['uid']][citem]['referee_link']}>{unpaidreferee[item['uid']][citem]['last_name']}</a></td>
                                                                                  <td>{unpaidreferee[item['uid']][citem]['email']}</td><td><a href={unpaidreferee[item['uid']][citem]['referer_link']}>{unpaidreferee[item['uid']][citem]['referer_name']}</a></td></tr></>
                                                                                 ))) : (
                                                                                   <><td colspan="4" align="center">No Referrals found.</td></>
                                                                                )

                                                                                }
                                                                      </tbody>
                                                                      </table></td>
                                                                </tr>
                                                                 </table>
                                                          </td></tr>
                                                               )}
                                                           </>
                                                          )}  
                                                        </>
                                                        )}
                                                    </>
                                
                                                })}  
                                                
                                                
                                               
                                                </tbody></table><br/><br/></>
                                            )}
                  {submittedsalespersonList.length > 0  && Object.values(totalreferee1).length > 0 && submittedData.pay_start_date && submittedData.pay_end_date && (
                                                <><table className="referral_count_list"><tbody><tr><th>Name Of Salesperson</th><th>Total Referrals</th><th>Paid Referee</th><th>UnPaid Referee</th></tr>
                                                
                                                {submittedsalespersonList.map((item, index) => {
                                                        
                                                        const paid_referee_length = paidreferee1[item['uid']]?Object.keys(paidreferee1[item['uid']]).length:0;
                                                        const unpaid_referee_length = unpaidreferee1[item['uid']]?Object.keys(unpaidreferee1[item['uid']]).length:0;
                                                        const total_length = paid_referee_length+unpaid_referee_length;
                                                    return <>
                                                        {item['uid'] != null && (
                                                          
                                                        <><tr><td>{item['name']}</td>
                                                            <td>
                                                              <a href onClick={() => handleClick('total_length',item['uid'])}>{total_length}</a>
                                                            </td>
                                                            <td>
                                                              <a href onClick={() => handleClick('paid_referee_length',item['uid'])}>{paid_referee_length}</a>
                                                            </td>
                                                            <td>
                                                              <a href onClick={() => handleClick('unpaid_referee_length',item['uid'])}>{unpaid_referee_length}</a>
                                                            </td>
                                                          </tr>
                                                           {openTotalTable[item['uid']] === true && (
                                                            <>
                                                            {(totaltableContent.content === 'total_length' && item['uid']) && (
                                                          <tr><td colspan="15">
                                                            <table>
                                                              {/* Use tableContent to generate dynamic content */}
                                                              
                                                                <tr>
                                                                  <td><table class="table table-bordered table-hover" style={{ width: '80%', margin: 'auto' }}>
				                                                              <tbody><tr align="center"><th colspan="4" align="center">Total Referrals</th></tr>
				                                                                      <tr><th>First Name</th><th>Last Name</th><th>Email</th><th>Referer</th></tr>
                                                                              {totalreferee1[item['uid']] && Object.keys(totalreferee1[item['uid']]).length > 0 ? (
                                                                                Object.keys(totalreferee1[item.uid]).map((citem,cvalue) => (
                                                                                  <><tr><td><a href={totalreferee1[item['uid']][citem]['referee_link']}>{totalreferee1[item['uid']][citem]['first_name']}</a></td><td><a href={totalreferee1[item['uid']][citem]['referee_link']}>{totalreferee1[item['uid']][citem]['last_name']}</a></td>
                                                                                  <td>{totalreferee1[item['uid']][citem]['email']}</td><td><a href={totalreferee1[item['uid']][citem]['referer_link']}>{totalreferee1[item['uid']][citem]['referer_name']}</a></td></tr></>
                                                                                 ))) : (
                                                                                   <><td colspan="4" align="center">No salespeople found.</td></>
                                                                                )

                                                                                }
                                                                      </tbody>
                                                                      </table></td>
                                                                </tr>

                                                             </table>
                                                          </td></tr>
                                                             )}
                                                              </>
                                                            
                                                             )}
                                                             {openPaidTable[item['uid']] === true && (
                                                              <>
                                                              {(paidtableContent.content === 'paid_referee_length' && item['uid']) && (
                                                                <tr><td colspan="15">
                                                            <table>
                                                                <tr>
                                                                  <td><table class="table table-bordered table-hover" style={{ width: '80%', margin: 'auto' }}>
				                                                              <tbody><tr align="center"><th colspan="4" align="center">Paid Referee</th></tr>
				                                                                      <tr><th>First Name</th><th>Last Name</th><th>Email</th><th>Referer</th></tr>
                                                                              {paidreferee1[item['uid']] && Object.keys(paidreferee1[item['uid']]).length > 0 ? (
                                                                                Object.keys(paidreferee1[item.uid]).map((citem,cvalue) => (
                                                                                  <><tr><td><a href={paidreferee1[item['uid']][citem]['referee_link']}>{paidreferee1[item['uid']][citem]['first_name']}</a></td><td><a href={paidreferee1[item['uid']][citem]['referee_link']}>{paidreferee1[item['uid']][citem]['last_name']}</a></td>
                                                                                  <td>{paidreferee1[item['uid']][citem]['email']}</td><td><a href={paidreferee1[item['uid']][citem]['referer_link']}>{paidreferee1[item['uid']][citem]['referer_name']}</a></td></tr></>
                                                                                 ))) : (
                                                                                   <><td colspan="4" align="center">No Referrals found.</td></>
                                                                                )

                                                                                }
                                                                      </tbody>
                                                                      </table></td>
                                                                </tr>
                                                              </table>
                                                          </td></tr>
                                                             )}
                                                              </>
                                                            
                                                             )}
                                                             {openUnPaidTable[item['uid']] === true && (
                                                               <>
                                                              {(unpaidtableContent.content === 'unpaid_referee_length' && item['uid']) && (
                                                                 <tr><td colspan="15">
                                                            <table>
                                                                <tr>
                                                                  <td><table class="table table-bordered table-hover" style={{ width: '80%', margin: 'auto' }}>
				                                                              <tbody><tr align="center"><th colspan="4" align="center">UnPaid Referee</th></tr>
				                                                                      <tr><th>First Name</th><th>Last Name</th><th>Email</th><th>Referer</th></tr>
                                                                              {unpaidreferee1[item['uid']] && Object.keys(unpaidreferee1[item['uid']]).length > 0 ? (
                                                                                Object.keys(unpaidreferee1[item.uid]).map((citem,cvalue) => (
                                                                                  <><tr><td><a href={unpaidreferee1[item['uid']][citem]['referee_link']}>{unpaidreferee1[item['uid']][citem]['first_name']}</a></td><td><a href={unpaidreferee1[item['uid']][citem]['referee_link']}>{unpaidreferee1[item['uid']][citem]['last_name']}</a></td>
                                                                                  <td>{unpaidreferee1[item['uid']][citem]['email']}</td><td><a href={unpaidreferee1[item['uid']][citem]['referer_link']}>{unpaidreferee1[item['uid']][citem]['referer_name']}</a></td></tr></>
                                                                                 ))) : (
                                                                                   <><td colspan="4" align="center">No Referrals found.</td></>
                                                                                )

                                                                                }
                                                                      </tbody>
                                                                      </table></td>
                                                                </tr>
                                                             </table>
                                                          </td></tr>
                                                             )}
                                                              </>
                                                            
                                                             )}
                                                            
                                                         
                                                        </>
                                                        )}
                                                    </>
                                
                                                })}  
                                                
                                                
                                               
                                                </tbody></table><br/><br/></>
                                            )}
                  
                   {submittedData && (
                    <>
                 
                 <div className="referral-wallet-report-table">
                                           <table className="">
                                                <div style={{ width: '100%' }}>
                                                <DataGrid
                                                rows={rows}
                                                columns={columnsmain}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={() => crypto.randomUUID()}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                                //disableColumnResize={true}
                                            />
                                               </div>
                                            </table>
                                            </div>
                                                           
                                            </>
                 )}
</div>
            </div>
            <div className="right">
                 
            </div>
        </div>
               )}
    </>
    );
};
export default ReferralWalletReport;